export default function getEnv() {
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
    return 'dev';
  }
  return /^test/.test(location.hostname) ? 'test' : 'prod';
}
//# sourceMappingURL=index.js.map